var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.customfield.type === 'select')?_c('FilterSelect',_vm._g({attrs:{"title":_vm.customfield.name,"options":_vm.options}},_vm.$listeners)):_c('FilterText',_vm._g({attrs:{"title":_vm.customfield.name}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }